/*
 * One list-reorder, extracted so the drag-and-drop handlers and the up/down
 * buttons share a single definition of "move this item there" - and so the
 * arithmetic is testable without mounting a page that requires a signed-in
 * admin context.
 */

/**
 * Returns a copy of `items` with the element at `from` moved to `to`. Indexes
 * outside the list, or a move to the same place, return the original array
 * unchanged - callers use identity to detect "nothing happened".
 */
export function reorderList<T>(items: readonly T[], from: number, to: number): readonly T[] {
  if (from === to) return items;
  if (from < 0 || from >= items.length || to < 0 || to >= items.length) return items;
  const next = [...items];
  const [moved] = next.splice(from, 1);
  if (moved === undefined) return items;
  next.splice(to, 0, moved);
  return next;
}
